import { CoverPicture, ErrorSummary, RightSideModal, RightSideModalTitle } from 'components';
import * as c from 'models/constants';
import * as React from 'react';
import { IStore } from 'redux/IStore';
import { Dispatch, connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { ITranslateProps, InjectedFormProps } from 'models/common';
import { InjectedManualBookingModalProps } from '../';
import { translate } from 'react-i18next';
import { IBlockedTimeFormData } from 'models/shop/manualbooking';
import { RightSideModalFooter } from 'components/RightSideModal';
import { addURLSearchParams, thumbUrl, timePickerProps } from 'helpers/common';
import moment = require('moment');
import { momentWithTimezone } from 'redux/modules/shop/helpers';
import { Field } from 'redux-form';
import { createEndTimeValidationFuntion, maxLength, required } from 'helpers/validationattributes';
import { BookingDatePicker, BookingInputField, BookingTextareaField } from 'components/FormControls';
import { IOfficeMember } from 'models/shop/members';
import {
	addBlockedTime,
	clearBookingTimetablesErrors,
	deleteOtherScheduleTime,
	moveBlockedTime,
} from 'redux/modules/shop/bookingtimetables';
import { IBookingTimeTable } from 'models/shop/bookingtimetables';
import { IRescheduleProps } from 'models/shop/schedule';
require('./style.scss');
const classNames = require('classnames');

interface IOwnProps {
	shopId?: string;
	officeId?: string;
	resourceId?: string;
	time?: string;
	endTime?: string;
	timezone?: string;
	timetables?: IBookingTimeTable[];
	description?: string;
	rescheduleProps?: IRescheduleProps;
}

interface IState {}

type IProps = IOwnProps &
	ReturnType<typeof stateToProps> &
	ReturnType<typeof dispatchToProps> &
	ITranslateProps &
	InjectedFormProps &
	InjectedManualBookingModalProps;

const maxLength260 = maxLength(260);

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AddEditBlockedTimeScreenComponent extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.handleDateTimeChange = this.handleDateTimeChange.bind(this);
		this.turnEditModeOn = this.turnEditModeOn.bind(this);
		this.onSubmit = this.onSubmit.bind(this);

		this.formRef = React.createRef();

		this.state = {};
	}

	formRef: React.Ref<HTMLFormElement>;

	componentDidMount(): void {
		// close on edit refresh
		if (this.props.mode === 'editBlockedTime' && !this.props?.timetables?.length) {
			this.props.closeModal();
		}

		this.props?.clearBookingTimetablesErrors?.();
		// If drag and drop enter edit mode immediately
		if (this.props?.rescheduleProps?.startTimeMoment) {
			this.props.change('isEditModeEnabled', true);
		}
	}

	onSubmit() {
		const { mode, currentFormValues, timezone, officeId } = this.props;
		const isEditModeOff = mode === 'editBlockedTime' && !currentFormValues?.isEditModeEnabled;
		mode === 'editBlockedTime'
			? isEditModeOff
				? this.turnEditModeOn()
				: this.props
						.moveBlockedTime(currentFormValues, timezone)
						.then((success) => {
							if (success) {
								this.props.closeModal();
							}
						})
						.catch((err) => console.error(err))
			: this.props.addBlockedTime(currentFormValues, officeId, timezone).then((success) => {
					if (success) {
						this.props.closeModal();
					}
			  });
	}

	private handleDateTimeChange(value: string, type: 'time' | 'date') {
		const oldDateTime = momentWithTimezone(this.props.timezone, this.props.time);
		const newDateTime = momentWithTimezone(this.props.timezone, value);

		let newDate: moment.Moment;
		let newTimeUnix: number;

		// If the date changed then take the old time and new date
		if (type === 'date') {
			newDate = newDateTime.startOf('day');
			newTimeUnix = oldDateTime.unix() - oldDateTime.startOf('day').unix();
		} else {
			newDate = oldDateTime.startOf('day');
			newTimeUnix = newDateTime.unix() - newDateTime.startOf('day').unix();
		}

		newDate = newDate.clone().add(newTimeUnix, 'seconds');

		addURLSearchParams('time', newDate.toISOString());
	}

	private onBlockedTimeResourceChange = (resId: string) => {
		this.props.change('resourceId', resId);
	};

	private turnEditModeOn = () => {
		const timeName = this.props.currentFormValues.name;
		if (timeName === '0' || timeName === '1' || timeName === '2' || timeName === '3') {
			this.props.change('name', '');
		}
		this.props.change('isEditModeEnabled', true);
	};

	public render() {
		const { t, timezone, handleSubmit, currentFormValues } = this.props;
		const isRightButtonDisabled = false;
		const isEditModeOff = this.props.mode === 'editBlockedTime' && !currentFormValues?.isEditModeEnabled;
		const resource = currentFormValues?.resourceId
			? this.props?.currentOffice?.staff?.find((s) => s.id === currentFormValues.resourceId)
			: null;
		const timeName =
			currentFormValues?.name === '0' ||
			currentFormValues?.name === '1' ||
			currentFormValues?.name === '2' ||
			currentFormValues?.name === '3'
				? t(`Shop_Appointments_TimeSlotType_${currentFormValues.name}`)
				: currentFormValues.name;
		const resFullName = resource ? resource.name.split(' ') : null;

		const validateEndTime = [required];
		if (currentFormValues.startTime) {
			validateEndTime.push(createEndTimeValidationFuntion(currentFormValues.startTime, t, timezone));
		}

		const appointmentFields = (
			<>
				<div className="row">
					<div className="col-12">
						<Field
							name="name"
							component={BookingInputField}
							placeholder={t('ManualBookingModal_AddEditBlockedTime_NameExample')}
							className="add-edit-blocked-time__name"
							information={
								t('Shop_ManageShop_Offices_ManageOffice_Label_Name') +
								' ' +
								`(${t('User_ShopCard_Services_Optional').toLowerCase()})`
							}
						/>
					</div>
					<div className="col-12">
						<h3 className="add-edit-blocked-time__sectionTitle dateTime">{t('Shop_Appointments_DateTime')}</h3>
					</div>
					<div className="col-12">
						<Field
							name={'date'}
							type="text"
							component={BookingDatePicker}
							label={t('BSPortal_Common_Date')}
							information={t('BSPortal_Common_Date')}
							validate={[required]}
							hideYearArrows={true}
							timezone={timezone}
							onChange={(_event, newValue) => this.handleDateTimeChange(newValue, 'date')}
							className={'add-edit-blocked-time__dateField'}
							minDate={momentWithTimezone(timezone).startOf('day').toDate()} // cannot create appointment in the past
						/>
					</div>
					<div className="col-6">
						<Field
							name={'startTime'}
							type="text"
							component={BookingDatePicker}
							information={t('Shop_ManageShop_Location_Label_OpeningTimes_From')}
							label={t('Shop_ManageShop_Location_Label_OpeningTimes_From')}
							{...timePickerProps(moment().startOf('day').toDate(), moment().endOf('day').toDate())}
							timezone={timezone}
							validate={[required]}
							onChange={(_event, newValue) => this.handleDateTimeChange(newValue, 'time')}
						/>
					</div>
					<div className="col-6">
						<Field
							name={'endTime'}
							type="text"
							component={BookingDatePicker}
							information={t('Shop_ManageShop_Location_Label_OpeningTimes_To')}
							validate={validateEndTime}
							label={t('Shop_ManageShop_Location_Label_OpeningTimes_To')}
							{...timePickerProps(new Date(currentFormValues?.startTime), moment().endOf('day').toDate())}
							timezone={timezone}
						/>
					</div>
					<div className="col-12">
						<h3 className="add-edit-blocked-time__sectionTitle notes">{t('User_UserCard_NotesTitle')}</h3>
					</div>
					<div className="col-12">
						<Field
							className="add-edit-blocked-time__appointmentNotes__appointmentNoteField"
							name="note"
							component={BookingTextareaField}
							type="textarea"
							rows={7}
							validate={[maxLength260]}
							maxLength={260}
							information={
								t('Shop_ManageShop_General_Label_Description') +
								' ' +
								`(${t('User_ShopCard_Services_Optional').toLowerCase()})`
							}
							hideCounter={true}
						/>
					</div>
					<div className="col-12">
						<h3 className="add-edit-blocked-time__sectionTitle staff">{t('Shop_Appointments_Details_Staff_Label')}</h3>
					</div>
					<div className="add-edit-blocked-time__editResourcesWrapper">
						<div className="row">
							{this.props?.currentOffice?.staff?.map((res, idx) => {
								const resFullName = res ? res.name.split(' ') : null;

								return (
									<div className="col-md-6 col-12" key={res.id}>
										<div className={`add-edit-blocked-time__resourceContainer ${idx > 1 ? 'resourceMargin' : ''}`}>
											<label className="add-edit-blocked-time__resourceButton">
												<input
													key={res.id + Number(idx)}
													name={res.name + Number(idx)}
													value={res.id}
													type="radio"
													checked={res.id === currentFormValues.resourceId}
													onChange={() => this.onBlockedTimeResourceChange(res.id)}
												/>
												<div className="add-edit-blocked-time__resourceWrapper">
													<CoverPicture
														imageUrl={thumbUrl(res?.picture, 'medium') || ''}
														hasPicture={Boolean(res?.picture)}
													/>
													<div className="add-edit-blocked-time__resourceInfoWrapper">
														<p className="add-edit-blocked-time__resourceName">
															{resFullName?.[0]} {resFullName?.[resFullName?.length - 1].charAt(0)}.
														</p>
														<p className="add-edit-blocked-time__resourceTitle">
															{(res as IOfficeMember)?.jobTitle?.substring(0, 14)}
														</p>
													</div>
												</div>
											</label>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</>
		);

		const editBlockedTimeDetails = (
			<div className="row">
				<div className="col-12">
					<h3 className="add-edit-blocked-time__sectionTitle dateTimeUE">{t('Shop_Appointments_DateTime')}</h3>
					<p className="add-edit-blocked-time__startEndTime">
						{momentWithTimezone(timezone, this.props?.initialValues?.startTime).format('dddd, LL')}{' '}
						<span className="add-edit-blocked-time__to">
							{t('Shop_ManageShop_Location_Label_OpeningTimes_From').toLowerCase()}
						</span>{' '}
						{momentWithTimezone(timezone, this.props?.initialValues?.startTime).format('HH:mm')}{' '}
						<span className="add-edit-blocked-time__to">
							{t('Shop_ManageShop_Location_Label_OpeningTimes_To').toLowerCase()}
						</span>{' '}
						{momentWithTimezone(timezone, this.props?.initialValues?.endTime).format('HH:mm')}
					</p>
					{this.props?.initialValues?.note && (
						<>
							<h3 className="add-edit-blocked-time__sectionTitle notesUE">{t('User_UserCard_NotesTitle')}</h3>
							<div className="add-edit-blocked-time__clientNotes">{this.props?.initialValues?.note}</div>
						</>
					)}
					<h3
						className={classNames('add-edit-blocked-time__sectionTitle staffUE', {
							noNote: !this.props?.initialValues?.note,
						})}
					>
						{t('Shop_Appointments_Details_Staff_Label')}
					</h3>
					<div className="add-edit-blocked-time__resourceWrapper">
						<CoverPicture
							imageUrl={thumbUrl(resource?.picture, 'medium') || ''}
							hasPicture={Boolean(resource?.picture)}
						/>
						<div className="add-edit-blocked-time__resourceInfoWrapper">
							<p className="add-edit-blocked-time__resourceName">
								{resFullName?.[0]} {resFullName?.[resFullName?.length - 1].charAt(0)}.
							</p>
							<p className="add-edit-blocked-time__resourceTitle">
								{(resource as IOfficeMember)?.jobTitle?.substring(0, 14)}
							</p>
						</div>
					</div>
				</div>
			</div>
		);

		return (
			<RightSideModal
				size="small"
				header={
					<>
						<RightSideModalTitle
							title={
								this.props.mode === 'editBlockedTime'
									? !isEditModeOff
										? t('ManualBookingModal_EditBlockedTime_Main_Title')
										: timeName
									: t('ManualBookingModal_AddBlockedTime_Main_Title')
							}
							closeModalClick={
								(this.props.mode === 'add' && !this.props.dirty) ||
								(this.props?.mode === 'editBlockedTime' && !this.props?.currentFormValues?.isEditModeEnabled)
									? this.props.closeModal
									: this.props.startCloseModal
							}
						/>
					</>
				}
				footer={
					<>
						<RightSideModalFooter
							rightButtonClick={() => {
								(this.formRef as any)?.current?.requestSubmit();
							}}
							rightButtonText={isEditModeOff ? t('BSPortal_Common_Edit') : t('BSPortal_Common_Save')}
							leftButtonClick={() =>
								this.props.mode === 'editBlockedTime'
									? this.props
											.deleteBlockedTime()
											.then(() => {
												this.props.closeModal();
											})
											.catch((err) => console.error(err))
									: null
							}
							leftButtonText={this.props.mode === 'editBlockedTime' ? t('BSPortal_Common_Delete') : null}
							isRightButtonDisabled={isRightButtonDisabled}
							rightButtonIcon={isEditModeOff ? 'editPencil' : undefined}
							rightButtonCustomClass={isEditModeOff ? 'editEnable' : ''}
						>
							<ErrorSummary
								error={this.props.bookingTimeTables?.error}
								message={this.props.bookingTimeTables?.message}
							/>
						</RightSideModalFooter>
					</>
				}
			>
				<form ref={this.formRef} onSubmit={handleSubmit(this.onSubmit)}>
					{!isEditModeOff ? appointmentFields : editBlockedTimeDetails}
				</form>
			</RightSideModal>
		);
	}
}

const stateToProps = (state: IStore, ownProps: IOwnProps) => {
	const searchParams = new URLSearchParams(window.location.search);
	const currentOffice = state?.manageShop?.shop?.offices.find((off) => off.id === ownProps.officeId) || null;
	let recheduleTime: string = undefined;
	let rescheduleEndtime: string = undefined;

	if (ownProps?.rescheduleProps) {
		recheduleTime = moment(ownProps.rescheduleProps.startTimeMoment).toISOString();

		if (ownProps?.time && ownProps?.endTime) {
			const timeDiff: number = moment(ownProps.endTime).unix() - moment(ownProps.time).unix();
			rescheduleEndtime = moment(ownProps.rescheduleProps.startTimeMoment).add(timeDiff, 'seconds').toISOString();
		}
	}

	const initialValues: IBlockedTimeFormData = {
		date: ownProps.time || searchParams.get('time'),
		startTime: recheduleTime || ownProps.time || searchParams.get('time'),
		endTime:
			rescheduleEndtime ||
			ownProps.endTime ||
			moment(ownProps.time || searchParams.get('time'))
				.add(30, 'minutes')
				.toISOString(),
		resourceId: ownProps.resourceId || searchParams.get('resourceId'),
		note: ownProps.description || '',
		name: ownProps?.timetables?.[0]?.name || '',
	};
	let currentFormValues: IBlockedTimeFormData = initialValues;

	if (state.form[c.FORM_NAME_BLOCKED_TIME] && state.form[c.FORM_NAME_BLOCKED_TIME].values) {
		currentFormValues = state.form[c.FORM_NAME_BLOCKED_TIME].values;
	}

	return {
		initialValues,
		currentFormValues,
		shopcard: state.shopcard,
		manageShop: state.manageShop,
		serviceGroups: state.serviceGroups,
		shopBookingTemplates: state.shopBookingTemplates,
		bookingTimeTables: state.bookingTimetables,
		currentOffice,
	};
};

const dispatchToProps = (dispatch: Dispatch<IStore>, ownProps: IOwnProps) => ({
	addBlockedTime: (form: IBlockedTimeFormData, officeId: string, timezone: string) =>
		dispatch(addBlockedTime(form, officeId, timezone)),
	moveBlockedTime: (form, timezone) => dispatch(moveBlockedTime(ownProps.timetables, form, timezone)),
	deleteBlockedTime: () => dispatch(deleteOtherScheduleTime(ownProps.timetables)),
	clearBookingTimetablesErrors: () => dispatch(clearBookingTimetablesErrors()),
});

export const AddEditBlockedTimeScreen = connect(
	stateToProps,
	dispatchToProps,
)(
	reduxForm({
		form: c.FORM_NAME_BLOCKED_TIME,
		enableReinitialize: false,
		destroyOnUnmount: true,
	})(AddEditBlockedTimeScreenComponent),
);
